<div class="container-fluid">
    <div class="row">
        <div class="col-12">
            <div class="card" style="padding: 10px; border-radius: 10px;">
                <div class="form-row">
                    <div class="form-group col-6">
                        <label for="id">FINT ID</label>
                        <input type="text" name="" id="" [(ngModel)]="finterstal_id" class="form-control">
                        <!-- <div class="ng-autocomplete">
                            <ng-autocomplete 
                              [data]="fintrestal_idList"
                              [searchKeyword]="'_id'"
                              (selected)='selectEvent($event)'
                              (inputChanged)='onChangeSearch($event)'
                              (inputFocused)='onFocused($event)'
                              [itemTemplate]="itemTemplate"
                              [notFoundTemplate]="notFoundTemplate">                                 
                            </ng-autocomplete>
                            
                            <ng-template #itemTemplate let-item>
                            <a [innerHTML]="item._id"></a>
                            </ng-template>
                            
                            <ng-template #notFoundTemplate let-notFound>
                            <div [innerHTML]="notFound"></div>
                            </ng-template>
                        </div> -->
                    </div>
                    <div class="form-group col-6">
                        <button class="btn btn-sm btn-dark" (click)="searchFin()">Search</button>
                    </div>
                    <div class="form-group col-6">
                        <label for="id">Account Number</label>
                        <input type="text" name="" id="" [(ngModel)]="acc_no" class="form-control">
                        <!-- <div class="ng-autocomplete">
                            <ng-autocomplete 
                              [data]="fintrestal_idList"
                              [searchKeyword]="'_id'"
                              (selected)='selectEvent($event)'
                              (inputChanged)='onChangeSearch($event)'
                              (inputFocused)='onFocused($event)'
                              [itemTemplate]="itemTemplate"
                              [notFoundTemplate]="notFoundTemplate">                                 
                            </ng-autocomplete>
                            
                            <ng-template #itemTemplate let-item>
                            <a [innerHTML]="item._id"></a>
                            </ng-template>
                            
                            <ng-template #notFoundTemplate let-notFound>
                            <div [innerHTML]="notFound"></div>
                            </ng-template>
                        </div> -->
                    </div>
                    <div class="form-group col-6">
                        <button class="btn btn-sm btn-dark" (click)="searchAcc()">Search</button>
                    </div>
                    <div class="form-group col-6">
                        <label for="id">Passport Number</label>
                        <input type="text" name="" id="" [(ngModel)]="passport_no" class="form-control">
                        <!-- <div class="ng-autocomplete">
                            <ng-autocomplete 
                              [data]="fintrestal_idList"
                              [searchKeyword]="'_id'"
                              (selected)='selectEvent($event)'
                              (inputChanged)='onChangeSearch($event)'
                              (inputFocused)='onFocused($event)'
                              [itemTemplate]="itemTemplate"
                              [notFoundTemplate]="notFoundTemplate">                                 
                            </ng-autocomplete>
                            
                            <ng-template #itemTemplate let-item>
                            <a [innerHTML]="item._id"></a>
                            </ng-template>
                            
                            <ng-template #notFoundTemplate let-notFound>
                            <div [innerHTML]="notFound"></div>
                            </ng-template>
                        </div> -->
                    </div>
                    <div class="form-group col-6">
                        <button class="btn btn-sm btn-dark" (click)="searchPass()">Search</button>
                    </div>

                    <div class="form-group col-6">
                        <label for="id">CIF Number</label>
                        <input type="text" name="" id="" [(ngModel)]="cif_no" class="form-control" >
                        
                    </div>
                    <div class="form-group col-6">
                        <button class="btn btn-sm btn-dark" (click)="searchCIF()" >Search</button>
                    </div>


                    <div class="form-group col-6">
                        <label for="id">CID</label>
                        <input type="text" name="" id="" [(ngModel)]="cid" class="form-control" >
                        
                    </div>
                    <div class="form-group col-6">
                        <button class="btn btn-sm btn-dark" (click)="searchCID()" >Search</button>
                    </div>


                    <div class="form-group col-4">
                        <label for="id">Allocation Status</label>
                        <select name="" id="" class="form-control" [(ngModel)]="allocation_status">
                            <option value="">Choose</option>
                            <option value="not allocated">Not Allocated</option>
                            <option value="allocated">Allocated</option>
                        </select>
                    </div>
                    <div class="form-group col-4">
                        <label for="id">Customer Status</label>
                        <select name="" id="" class="form-control" [(ngModel)]="status">
                            <option value="">Choose</option>
                            <option value="live">Active</option>
                            <option value="dead">In active</option>
                        </select>
                    </div>
                </div>

                
                <!-- <div class="row d-flex justify-content-end">
                    <button class="btn btn-sm btn-dark mr-5" (click)="searchResult()">Search</button>
                </div> -->
            </div>
        </div>

            
        <div class="col-12" *ngIf="searchResults == null" style="text-align: center;">
            <p style="padding: 10px; font-size: 16px;"><b>Please Select search params</b></p>
        </div>
        <div class="col-12">
            <hr>
            <table class="table table-bordered">
                <thead class="table-dark" *ngIf="searchResults != null">
                    <tr>
                        <th>Bank ID</th>
                        <th>Portfolio ID</th>
                        <th>Finstrestle ID</th>
                        <th>Account Number</th>
                        <th>Passport Number</th>
                        <th>Options</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of searchResults">
                        <td>
                            <select [(ngModel)]="item.bank_id" class="form-control" disabled>
                                <option *ngFor="let item of origianl_bank_list" [value]="item._id">{{item.bank_name}}</option>
                            </select>
                        </td>
                        <td>
                            <select [(ngModel)]="item.porfolio_id" class="form-control" disabled>
                                <option *ngFor="let item of original_portfolio_list" [value]="item._id">{{item.portfolio_type}}</option>
                            </select>
                        </td>
                        <td>
                            {{item.finterstal_id}}
                        </td>
                        <td>
                            {{item.acc_no}}
                        </td>
                        <td>
                            {{item.passport_no}}
                        </td>
                        <td>
                            <button class="btn btn-sm btn-success mr-1 mt-1 mb-1" (click)="gotoCustomer('/admin_panel/user/createuser?_id='+item.finterstal_id,item)">view</button>
                            <button *ngIf="FollowUpShow" class="btn btn-sm btn-dark mr-1 mt-1 mb-1" (click)="stopFollowUp(item)">Stop FollowUp</button>
                            <button *ngIf="MarkCompletedShow" class="btn btn-sm btn-dark mr-1 mt-1 mb-1" (click)="markCompleted(item)">Mark as Completed</button>
                            <button *ngIf="WithdrawShow" class="btn btn-sm btn-dark mr-1 mt-1 mb-1" (click)="withdrawAccounts(item)">Withdraw Accounts</button>
                            <button *ngIf="BlockAccountShow" class="btn btn-sm btn-danger mr-1 mt-1 mb-1" (click)="blockAccounts(item)">Freeze Accounts</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>